/**
 * Copiar al portapapeles con toast (28/10/2026: salió de hooks/useVault.ts, que lo re-exporta; lo usan
 * RevealField del Vault y CodeBlock). Había 14 `navigator.clipboard.writeText` sueltos: usar esto.
 */
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

export function useCopy() {
  const { t } = useTranslation();
  return useCallback(
    async (text: string, label?: string) => {
      try {
        await navigator.clipboard.writeText(text);
        toast.success(label ?? t('common.copied', 'Copiado'));
      } catch {
        toast.error(t('common.copy_failed', 'No se pudo copiar'));
      }
    },
    [t],
  );
}
